import { ExamUnitType } from '@/enums/examUnitType.enum';

export default {
  type: 'object',
  properties: {
    date: {
      title: 'schema.examResult.date',
      type: 'string',
      calc: {
        when: '!this.date',
        func: '$methods.moment().format("YYYY-MM-DD")'
      },
      format: 'date',
      fieldRequired: true
    },
    score: {
      title: 'schema.examResult.score',
      type: 'number',
      fieldRequired: true,
      calc: {
        when: `this.examUnit === '${ExamUnitType.TIME}'`,
        func:
          '(this.timeInput.hour || 0) * 3600  + (this.timeInput.minute || 0) * 60 + (this.timeInput.second || 0) + (this.timeInput.hundredth || 0) / 100'
      }
    },
    profileId: {
      title: 'schema.examResult.profileId',
      type: 'number',
      fieldRequired: true
    },
    examId: {
      title: 'schema.examResult.examId',
      type: 'number',
      fieldRequired: true
    },
    examUnit: {
      type: 'string',
      computed: true
    },
    teamId: {
      type: 'number',
      fieldRequired: true
    },
    timeInput: {
      type: 'object',
      computed: true,
      properties: {
        hour: {
          title: 'schema.timeInput.hour',
          type: 'integer',
          fieldRequired: `$root.examUnit === '${ExamUnitType.TIME}'`
        },
        minute: {
          title: 'schema.timeInput.minute',
          type: 'integer',
          fieldRequired: `$root.examUnit === '${ExamUnitType.TIME}'`,
          maximum: 59
        },
        second: {
          title: 'schema.timeInput.second',
          type: 'integer',
          fieldRequired: `$root.examUnit === '${ExamUnitType.TIME}'`,
          maximum: 59
        },
        hundredth: {
          title: 'schema.timeInput.hundredth',
          type: 'integer',
          fieldRequired: `$root.examUnit === '${ExamUnitType.TIME}'`,
          maximum: 99
        }
      }
    }
  }
};
